// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureInfo_container__3lfvO","mainCard":"FeatureInfo_mainCard__Pf8yw","stack":"FeatureInfo_stack__qhssI","stackCard":"FeatureInfo_stackCard__2jaQ9"};